<div class="image-banner image-banner--shadow w-100 d-flex flex-column flex-center">
  <!-- <img pingParallax="-0.4" class="cover-img" src="/assets/images/events.jpg" alt="events page banner image" sizes="100vw" srcset="/assets/images/events-small.webp 480w, /assets/images/events.webp 1080w" /> -->
  <div class="banner-bg banner-bg--blurred" style="background-image: url('/assets/images/events-blurred.jpg')"></div>
  <div class="banner-bg mobile-hide" pingParallax="0.3" style="background-image: url('/assets/images/events.jpg')"></div>
  <div class="banner-bg mobile-show" style="background-image: url('/assets/images/events-small.jpg')"></div>

  <div class="overlay d-flex flex-column flex-center w-100 h-100" *ngIf="!eventNotFound; else notFoundBanner">
    <!-- <img class="header-icon" src="assets/logo/icon.png" alt="Ping logo" /> -->
    <h1 class="mt-3 text-light">{{ title || 'Upcoming Events' }}
      <br/>
      <ng-container *ngIf="searchInputs.city; else globalText">
        in {{ searchInputs?.area || searchInputs?.city }}
      </ng-container>
    </h1>
    <ping-city-select (selectCity)="updateCity($event)" [citySelected]="filters.city"></ping-city-select>
    <app-store-icons class="mt-2" page="Events-Banner"></app-store-icons>

  </div>
</div>

<ng-template #notFoundBanner>
  <div class="overlay d-flex flex-column flex-center w-100 h-100">
    <h1 class="my-3 text-light">This event could not be found</h1>
    <p class="text-light text-center">Please use our list below to find the event you were looking for, or maybe even find something new!</p>
  </div>
</ng-template>

<div class="page-content">

  <ng-template #blankSpace>
    <div class="py-4"></div>
  </ng-template>

  <ng-container *ngIf="$categories | async as categories; else blankSpace">

    <categories-bar (categorySelected)="updateCategory($event)" (subCategorySelected)="updateSubCategory($event)"
    [selectedSubCategory]="filters.subCategory"
    [selectedCategory]="filters.category"
    *ngIf="categories?.length"
    [categories]="categories" [fixed]="true" type="EVENT">
  </categories-bar>

    <div class="container mt-4">

      <div class="d-flex flex-row justify-content-between align-items-end mb-3 w-100 flex-wrap">
        <h3 class="heading h4 text-uppercase">Events
          <ng-container *ngIf="searchInputs.city; else globalText">
            in <span class="text-primary">{{ searchInputs?.area ? searchInputs?.area + ', ' : ''}}{{ searchInputs.city }}</span>
          </ng-container>
        </h3>
        <div class="row d-flex align-items-end mt-3" *ngIf="$cities | async as cities">

          <!-- <div class="col-6 col-md-4 my-2" *ngIf="currentCity?.areas?.length">
            <label class="text-uppercase font-weight-bold">Area</label>
            <div class="input-group input-group-lg">
              <select class="custom-select" id="citySelect" [(ngModel)]="filters.area"  (ngModelChange)="updateArea($event)">
                <option [ngValue]="null" class="text-medium">All of {{ currentCity.title || 'Global events' }}</option>
                <option [value]="a.title" *ngFor="let a of currentCity.areas">{{a.title}}</option>
              </select>
            </div>
          </div> -->
          <!-- <div class="col-6 my-2">
            <label class="text-uppercase font-weight-bold">In the mood for...</label>
            <div class="input-group input-group-lg">
              <select class="custom-select" id="categorySelect" [(ngModel)]="filters.category" (ngModelChange)="updateCategory($event)">
                <option [ngValue]="null" class="text-medium">Anything</option>
                <option [ngValue]="c" *ngFor="let c of categories | categoryCitiesFilter: this.searchInputs?.city || filters.city :'EVENT'">{{ c?.title}}</option>
              </select>
            </div>
          </div> -->
          <!-- <div class="my-2" *ngIf="subcategories?.length">
            <label class="text-uppercase font-weight-bold">More specifically?</label>
            <div class="input-group input-group-lg">
              <select class="custom-select" id="subcategorySelect" (ngModelChange)="updateSubCategory($event)" placeholser="All" *ngIf="subcategories?.length; else disabledSelect" [(ngModel)]="filters.subCategory">
                <option [ngValue]="null" class="text-medium" >Any {{ filters.category?.title }}</option>
                <option [value]="c?.title" *ngFor="let c of subcategories">{{ c?.title}}</option>
              </select>
              <ng-template #disabledSelect>
                <select class="custom-select" disabled>
                  <option ></option>
                </select>
              </ng-template>
            </div>
          </div> -->
          <!-- <div class="col-12 col-md-2 my-2">
            <div class="btn btn-success btn-lg" [ngClass]="{'btn--disabled': loadingMore}" (click)="search()">
              Search
            </div>
          </div> -->
        </div>

      </div>

    </div>

  </ng-container>

  <!-- For when no city is selected -->
  <ng-template #globalText>
    Globally
  </ng-template>

  <ng-container
  *ngIf="$events | async as events; else loading"
  >
  <section class="pt-0">
    <ng-container *ngIf="events?.items?.length; else empty">

        <div class="container">
          <div class="row">
            <ng-container *ngFor="let event of events.items | slice: 0: events?.items?.length < 4 ? events.items.length : 4; let i = index">
              <div
                class="col-12 col-md-6 px-2 mb-3"
                *ngIf="event?.id"
              >
                <ping-event-card

                  [imgSize]="'large'"
                  [event]="event"
                ></ping-event-card>
              </div>

            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="events?.items?.length > 4">

          <div class="container">

            <!-- DOWNLOAD TOUT -->
            <ping-download-app [curved]="true"></ping-download-app>

            <div class="row mt-3">
              <ng-container *ngFor="let event of events.items | slice: 4: events?.items?.length < 8 ? events.items.length : 8; let i = index">
                <div
                  class="col-12 col-md-6 px-2 mb-3"
                  *ngIf="event?.id"
                >
                    <ping-event-card

                      [imgSize]="'large'"
                        [event]="event"
                    ></ping-event-card>
                </div>
              </ng-container>

            </div>

              <!-- BLURRED OUT ITEMS -->
            <div class="row position-relative" *ngIf="events.items.length > 8; else fakeMore">

              <ng-container *ngFor="let event of events.items | slice: events?.items?.length - 3 : events?.items?.length -1; let i = index">
                <div
                  class="col-12 col-md-6 px-2 mb-3 locked-blurred"
                  *ngIf="event?.id"
                >
                  <ping-event-card

                    [imgSize]="'large'"
                      [event]="event"
                  ></ping-event-card>
                </div>
              </ng-container>

              <ping-download-app-locked titleText="Locked" subText="The web version of this search is limited to {{ events.items.length > 8 ? 8 : events.items.length }} events. Sign Up for free to access all our curated events." [page]="'Events'"></ping-download-app-locked>

            </div>

            <ng-template #fakeMore>
                <ping-download-app-cards [cardsAmount]="2" [height]="'25rem'" titleText="Locked" subText="The web version of this search is limited to {{ events.items.length > 8 ? 8 : events.items.length }} events. Sign Up for free to access all our curated events." [showTitles]="false" [page]="'Events'"></ping-download-app-cards>
            </ng-template>

          </div>

        </ng-container>

        <ng-container *ngIf="!loadingMore; else loading"></ng-container>


    </ng-container>
  </section>
</ng-container>

<ng-template #empty>
  <div class="d-flex flex-column flex-center mb-3">
    <img src="assets/vectors/empty.svg" class="empty-img" alt="Ping places empty placeholder image" />
    <p class="mb-0 mt-4 text-center">Sorry, we couldn't find any {{ title?.toLowerCase() || 'events' }} in {{ searchInputs?.area || searchInputs?.city || 'your location' }}.</p>
  </div>

  <!-- DOWNLOAD TOUT -->
  <!-- <div class="py-5 container">
    <ping-download-app [curved]="true"></ping-download-app>
  </div> -->
</ng-template>

  <ng-template #loading>
    <div class="container">
      <div class="row py-4">
        <div class="col-12 text-center">

          <ngx-skeleton-loader count="1" [theme]="{
            height: '4rem',
            width: '90%',
            'background-color': '#f1f1f1'
          }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" [theme]="{
            height: '8rem',
            width: '100%',
            'background-color': '#f1f1f1'
          }">
          </ngx-skeleton-loader>
        </div>

        <div class="col-12 col-sm-6">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '10rem',
              width: '100%',
              margin: '0.25em',
              'background-color': '#f1f1f1',
              'border-radius': 5
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-12 col-sm-6">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '10rem',
              width: '100%',
              margin: '0.25em',
              'background-color': '#f1f1f1',
              'border-radius': 5
            }"
          ></ngx-skeleton-loader>
        </div>


        <div class="col-12 col-sm-6">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '10rem',
              width: '100%',
              margin: '0.25em',
              'background-color': '#f1f1f1',
              'border-radius': 5
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="col-12 col-sm-6">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '10rem',
              width: '100%',
              margin: '0.25em',
              'background-color': '#f1f1f1',
              'border-radius': 5
            }"
          ></ngx-skeleton-loader>
        </div>

      </div>
    </div>
  </ng-template>
</div>


<div class="w-100 bg-light">
  <div class="container">
    <div class="py-5">
      <ping-subscribe-sendy [page]="'EVENTS PAGE'"></ping-subscribe-sendy>
    </div>
  </div>
</div>
